import { ActiviteBesoin, ActiviteEquipeConstition, ElementKey } from "@/models";

/** Whether an item with the same `id` as `search` exists in `array`. */
export const found = (array: ElementKey[], search: ElementKey): boolean => {
  if (array && search) {
    return array.some((el) => {
      if (el && search && el.id === search.id) {
        return true;
      } else {
        return false;
      }
    });
  } else {
    return false;
  }
};

/** Index of the item matching `search.id` in `array`, or `-1` if not found. */
export const index = (array: ElementKey[], search: ElementKey): number => {
  return array.findIndex((el) => {
    if (el && search && el.id === search.id) {
      return true;
    } else {
      return false;
    }
  });
};

/** Toggles `value` in `array`: removes it if already present (by id), appends it otherwise. Mutates and returns `array`. */
export const select = (
  array: ElementKey[] | ActiviteBesoin[] | ActiviteEquipeConstition[],
  value: ElementKey | ActiviteBesoin | ActiviteEquipeConstition
): ElementKey[] | ActiviteBesoin[] | ActiviteEquipeConstition[] => {
  return selectFunction(array, value);
};

/** Same as {@link select}, typed for `ActiviteBesoin[]` (competence requirement picklists). */
export const selectBesoin = (
  array: ActiviteBesoin[],
  value: ActiviteBesoin
): ActiviteBesoin[] => {
  return selectFunction(array, value);
};

/** Untyped toggle implementation shared by {@link select} and {@link selectBesoin}. */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
export const selectFunction = (array: any, value: any): any => {
  const foundIndex = index(array, value);
  if (foundIndex !== -1) {
    array.splice(foundIndex, 1);
  } else {
    array.push(value);
  }
  return array;
};
